<template>
    <div>
        <!-- Floating Button -->
        <button v-if="validRoute" class="chatbot-toggle" @click="toggleChatbot">
            💬
        </button>

        <!-- Chatbot Window -->
        <div v-if="isOpen" class="chatbot-container">
            <div class="chat-header">{{ $t("chat.header") }}</div>

            <div class="chat-messages" ref="messages">
                <div class="message bot-message">
                    {{ $t("chat.welcome") }}
                </div>

                <div v-for="(msg, index) in messages" :key="index"
                    :class="['message', msg.sender === 'user' ? 'user-message' : 'bot-message']">
                    {{ msg.text }}
                </div>
            </div>

            <div class="chat-input-area">
                <input type="text" v-model="userInput" :placeholder="$t('chat.placeholder')"
                    @keypress.enter="sendMessage">

                <button class="btn-modern btn-primary py-1 px-3" @click="sendMessage">
                    <i style="font-size: 20pt;" class="mdi mdi-send-variant"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Chatbot",
    data() {
        return {
            isOpen: false,
            userInput: "",
            messages: [],
        };
    },

    computed: {
        // Load translated KB dynamically from i18n
        knowledgeBase() {
            return this.$t("chat.knowledgeBase");
        },
        validRoute() {
            return this.$route.name!=='messenger';
        },
    },

    methods: {
        toggleChatbot() {
            this.isOpen=!this.isOpen;
            if (this.isOpen) {
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            }
        },

        async sendMessage() {
            if (!this.userInput.trim()) return;

            const text=this.userInput;
            this.messages.push({ text, sender: "user" });
            const question=text;
            this.userInput="";

            this.$nextTick(() => this.scrollToBottom());

            // Typing delay
            setTimeout(async () => {
                const botResponse=await this.getBotResponse(question);
                this.messages.push({ text: botResponse, sender: "bot" });
                this.$nextTick(() => this.scrollToBottom());
            }, 400);
        }
        ,

        getBotResponse(input) {
            const fallback = this.$t("chat.fallback");
            return this.$axios.post('/chatbot/ask', {
                question: input
            })
                .then(res => this.$t(res.data.answer))
                .catch(() => fallback);
        }
        ,

        scrollToBottom() {
            const box=this.$refs.messages;
            if (box) box.scrollTop=box.scrollHeight;
        }
    }
};
</script>

<style scoped>
/* Floating button */
.chatbot-toggle {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: var(--color-nz);
    color: white;
    border: none;
    padding: 15px 18px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 11;
}

/* Chatbot container */
.chatbot-container {
    position: fixed;
    bottom: 80px;
    right: 20px;
    width: 350px;
    height: 500px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 60;
}

/* Header */
.chat-header {
    background: var(--color-nz);
    color: white;
    padding: 15px;
    text-align: center;
    font-weight: bold;
}

/* Messages */
.chat-messages {
    flex-grow: 1;
    padding: 15px;
    overflow-y: auto;
    background: #e9e9e9;
}

.message {
    margin-bottom: 10px;
    padding: 8px 12px;
    border-radius: 15px;
    max-width: 80%;
    line-height: 1.4;
}

.user-message {
    background: var(--color-nz);
    color: white;
    margin-left: auto;
}

.bot-message {
    background: #f0f0f0;
    color: var(--color-3);
}

/* Input area */
.chat-input-area {
    display: flex;
    border-top: 1px solid var(--color-d);
    padding: 10px;
}

.chat-input-area input {
    flex-grow: 1;
    padding: 10px;
    border: 1px solid var(--color-d);
    border-radius: 20px;
    margin-right: 8px;
}



/* Mobile */
@media (max-width: 768px) {
    .chatbot-toggle {
        bottom: 70px;
        right: 10px;
    }

    .chatbot-container {
        right: 0px;

        width: 100%;
        bottom: 120px;
    }
}
</style>
